var map = {
	"./ad.svg": 1942,
	"./ae.svg": 65767,
	"./af.svg": 1204,
	"./ag.svg": 73813,
	"./ai.svg": 34339,
	"./al.svg": 99454,
	"./am.svg": 43183,
	"./ao.svg": 53629,
	"./ar.svg": 81912,
	"./as.svg": 86153,
	"./at.svg": 56710,
	"./au.svg": 71095,
	"./aw.svg": 79141,
	"./az.svg": 18912,
	"./ba.svg": 8782,
	"./bb.svg": 57133,
	"./bd.svg": 92083,
	"./be.svg": 86914,
	"./bf.svg": 7281,
	"./bg.svg": 71328,
	"./bh.svg": 23511,
	"./bi.svg": 9126,
	"./bj.svg": 31557,
	"./bm.svg": 70458,
	"./bo.svg": 34328,
	"./br.svg": 6045,
	"./bs.svg": 16572,
	"./bt.svg": 86755,
	"./bw.svg": 29712,
	"./by.svg": 54358,
	"./bz.svg": 26229,
	"./ca.svg": 68989,
	"./cd.svg": 48976,
	"./cf.svg": 35058,
	"./cg.svg": 38371,
	"./ch.svg": 64980,
	"./ci.svg": 2965,
	"./ck.svg": 29543,
	"./cl.svg": 27144,
	"./cm.svg": 23161,
	"./cn.svg": 73866,
	"./co.svg": 42683,
	"./cr.svg": 5665,
	"./cu.svg": 39601,
	"./cv.svg": 82498,
	"./cw.svg": 86227,
	"./cy.svg": 3845,
	"./cz.svg": 72070,
	"./de.svg": 16076,
	"./dj.svg": 42955,
	"./dk.svg": 49082,
	"./dm.svg": 75364,
	"./do.svg": 24486,
	"./dz.svg": 95099,
	"./ec.svg": 19205,
	"./ee.svg": 26635,
	"./eg.svg": 22665,
	"./er.svg": 88244,
	"./es.svg": 13877,
	"./et.svg": 3466,
	"./fi.svg": 19154,
	"./fj.svg": 897,
	"./fk.svg": 2448,
	"./fm.svg": 40990,
	"./fo.svg": 24540,
	"./fr.svg": 68777,
	"./ga.svg": 21193,
	"./gb.svg": 79258,
	"./gd.svg": 36164,
	"./ge.svg": 14181,
	"./gg.svg": 40759,
	"./gh.svg": 35552,
	"./gi.svg": 76113,
	"./gl.svg": 69548,
	"./gm.svg": 5005,
	"./gn.svg": 10638,
	"./gq.svg": 79577,
	"./gr.svg": 37226,
	"./gt.svg": 47572,
	"./gu.svg": 8853,
	"./gw.svg": 35431,
	"./hk.svg": 11606,
	"./hn.svg": 36987,
	"./hr.svg": 94463,
	"./ht.svg": 64529,
	"./hu.svg": 28576,
	"./id.svg": 18446,
	"./ie.svg": 46879,
	"./il.svg": 18790,
	"./im.svg": 33175,
	"./in.svg": 90052,
	"./io.svg": 41221,
	"./iq.svg": 96419,
	"./ir.svg": 39376,
	"./is.svg": 74913,
	"./it.svg": 61534,
	"./je.svg": 6330,
	"./jm.svg": 92162,
	"./jo.svg": 34880,
	"./jp.svg": 39207,
	"./ke.svg": 5113,
	"./kg.svg": 78555,
	"./kh.svg": 27292,
	"./ki.svg": 81565,
	"./km.svg": 52673,
	"./kn.svg": 47634,
	"./kp.svg": 21732,
	"./kr.svg": 77318,
	"./kw.svg": 83883,
	"./ky.svg": 55949,
	"./kz.svg": 26830,
	"./la.svg": 97464,
	"./lb.svg": 36299,
	"./li.svg": 58144,
	"./lk.svg": 50050,
	"./lr.svg": 30971,
	"./ls.svg": 13130,
	"./lt.svg": 23541,
	"./lu.svg": 97908,
	"./lv.svg": 69415,
	"./ly.svg": 92848,
	"./ma.svg": 13231,
	"./mc.svg": 62749,
	"./md.svg": 28818,
	"./me.svg": 78211,
	"./mg.svg": 10561,
	"./mh.svg": 53142,
	"./mk.svg": 66101,
	"./ml.svg": 94474,
	"./mm.svg": 36443,
	"./mn.svg": 55080,
	"./mo.svg": 36825,
	"./mp.svg": 67886,
	"./mq.svg": 5823,
	"./mr.svg": 26796,
	"./ms.svg": 62253,
	"./mt.svg": 52962,
	"./mu.svg": 83539,
	"./mv.svg": 92800,
	"./mw.svg": 33361,
	"./mx.svg": 35206,
	"./my.svg": 98007,
	"./mz.svg": 93412,
	"./na.svg": 5378,
	"./nato.svg": 63001,
	"./ne.svg": 20302,
	"./nf.svg": 14669,
	"./ng.svg": 79212,
	"./ni.svg": 88922,
	"./nl.svg": 50423,
	"./no.svg": 45828,
	"./np.svg": 30627,
	"./nr.svg": 62977,
	"./nu.svg": 3070,
	"./nz.svg": 89241,
	"./om.svg": 93141,
	"./pa.svg": 31892,
	"./pe.svg": 77704,
	"./pf.svg": 9595,
	"./pg.svg": 40778,
	"./ph.svg": 35901,
	"./pk.svg": 73278,
	"./pl.svg": 7009,
	"./pn.svg": 5283,
	"./pr.svg": 44311,
	"./ps.svg": 38982,
	"./pt.svg": 8393,
	"./pw.svg": 63578,
	"./py.svg": 30572,
	"./qa.svg": 9867,
	"./ro.svg": 6856,
	"./rs.svg": 85900,
	"./ru.svg": 7298,
	"./rw.svg": 99040,
	"./sa.svg": 18029,
	"./sb.svg": 88910,
	"./sc.svg": 10015,
	"./sd.svg": 67808,
	"./se.svg": 14257,
	"./sg.svg": 22355,
	"./si.svg": 38533,
	"./sk.svg": 26935,
	"./sl.svg": 7128,
	"./sm.svg": 41993,
	"./sn.svg": 43258,
	"./so.svg": 45963,
	"./sr.svg": 5822,
	"./ss.svg": 68399,
	"./st.svg": 2512,
	"./sv.svg": 9714,
	"./sx.svg": 7572,
	"./sy.svg": 33205,
	"./sz.svg": 91958,
	"./tc.svg": 38482,
	"./td.svg": 72413,
	"./tg.svg": 60318,
	"./th.svg": 46489,
	"./tibet.svg": 80157,
	"./tj.svg": 46107,
	"./tk.svg": 4138,
	"./tm.svg": 14484,
	"./tn.svg": 2343,
	"./to.svg": 62806,
	"./tr.svg": 93203,
	"./tt.svg": 71917,
	"./tv.svg": 15487,
	"./tw.svg": 77550,
	"./tz.svg": 51435,
	"./ua.svg": 42343,
	"./ug.svg": 18553,
	"./us.svg": 55717,
	"./uy.svg": 61375,
	"./uz.svg": 82348,
	"./ve.svg": 85702,
	"./vi.svg": 63490,
	"./vn.svg": 33709,
	"./vu.svg": 30934,
	"./ws.svg": 67115,
	"./ye.svg": 25647,
	"./za.svg": 20054,
	"./zm.svg": 95730,
	"./zw.svg": 69848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38641;